import React from 'react';
import Container from 'components/Container/Container';
import { Typography } from '@mui/material';

export default function PageNotFound() {
  return (
    <React.Fragment>
      <Container>
        <Typography pt={4} pb={1} variant="h4">
          Oops! Sorry, the page not found.
        </Typography>
        <Typography pb={4} variant="h5">
          The link you followed probably broken or the page has been removed.
        </Typography>
      </Container>
    </React.Fragment>
  );
}
